<template>
  <div class="white-section mt-2 box-info">
    <permission-rooms-repeater :v="$v"></permission-rooms-repeater>
    <div class="d-flex justify-content-end mb-2">
      <b-button
          size="sm"
          variant="primary"
          @click="updateUser"
      >{{ $t("general.submit") }}
      </b-button
      >
    </div>
  </div>
</template>

<script>
import PermissionRoomsRepeater from "@/components/permissions/PermissionRoomsRepeater";
import {mapGetters} from "vuex";
import {
  BButton,
} from "bootstrap-vue";
import {
  required,requiredIf
} from "vuelidate/lib/validators";

export default {
  components: {PermissionRoomsRepeater, BButton},
  data: () => ({
  }),
  created() {
    this.$store.commit('permissions/RESET_PERMISSION_ROOMS');
      this.$store.commit("SET_IS_LOADING", true)
    this.getPermissionRooms();
    this.searchUnits();
    if (!this.userToEdit) {
      this.$store.dispatch('user/findUser', this.$route.params.userId).then((res) => {
    //     this.pushBreadcrumb({text: 'addPermissions',to:{name:'assignPermission' }, params:{
    //   userId: res._id
    // }, translate:true});
        this.pushBreadcrumb({text: 'permissionRooms', to: {name: 'addPermissions'}, translate: true});
        this.pushBreadcrumb({text: res.firstName + ' ' + res.lastName, translate: false});
        this.setCurrentBreadcrumb([{
          text: 'permissionRooms',
          to: {name: 'addPermissions'},
          translate: true
        }, {text: res.firstName + ' ' + res.lastName, translate: false}]);
        this.$store.commit("user/SET_USER_TO_EDIT", res);
        this.userToEdit.permissionRooms.length ? this.userPermissionRooms = this.userToEdit.permissionRooms : this.userPermissionRooms = [{
          // id: (this.nextTodoId += this.nextTodoId),
          roomId: "",
          permissionRoomId: "",
        }]
        if (this.userToEdit.permissionRooms.length) {
          this.userToEdit.permissionRooms.forEach((p, index) => {
            this.searchRoomById(p.roomId, index)
          })
        }else{
          // this.searchUnits();
        }
      })

    } else {
       this.pushBreadcrumb({text: 'permissionRooms', to: {name: 'addPermissions'}, translate: true});
        this.pushBreadcrumb({text: this.userToEdit.firstName + ' ' + this.userToEdit.lastName, translate: false});
        this.setCurrentBreadcrumb([{
          text: 'permissionRooms',
          to: {name: 'addPermissions'},
          translate: true
        },{text: this.userToEdit.firstName + ' ' + this.userToEdit.lastName, translate: false}]);
      this.userToEdit.permissionRooms.length ? this.userPermissionRooms = this.userToEdit.permissionRooms : this.userPermissionRooms = [{
        // id: (this.nextTodoId += this.nextTodoId),
        roomId: "",
        permissionRoomId: "",
      }]
      if (this.userToEdit.permissionRooms.length) {
        this.userToEdit.permissionRooms.forEach((p, index) => {
          // this.searchRooms(p.roomId.unitId, index)
          this.searchRoomById(p.roomId, index)
        })
      }
    }
      this.$store.commit("SET_IS_LOADING", false)

    // this.userPermissionRooms.forEach((u, index) =>{
    //
    //   this.searchRooms(index);
    // })

  },
  validations() {
    return {
      userPermissionRooms: {
        $each: {
          roomId: {
            // _id: {
            required: requiredIf(() => {
              if(this.userPermissionRooms.length > 1) {
                return true
              }else{

                return false
              }

            }),
            // }
          },
          unitId: {
            required: requiredIf(() => {
              if(this.userPermissionRooms.length > 1) {
                return true
              }else{

                return false
              }

            }),
          },
          permissionRoomId: {
            required: requiredIf(() => {
              if(this.userPermissionRooms.length > 1) {
                return true
              }else{
                return false
              }

            }),
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      userToEdit: 'user/userToEdit',
      permissionRooms: "permissionRooms/permissionRooms",
    }),
    userPermissionRooms: {
      set(userPermissionRooms) {
        this.$store.commit("permissions/SET_USER_PERMISSION_ROOMS", userPermissionRooms);
      },
      get() {
        return this.$store.getters["permissions/userPermissionRooms"];
      },
    },
    userPermissionRepeaterRooms: {
      set(userPermissionRepeaterRooms) {
        this.$store.commit("permissions/SET_USER_PERMISSION_REPEATER_ROOMS", userPermissionRepeaterRooms);
      },
      get() {
        return this.$store.getters["permissions/userPermissionRepeaterRooms"];
      },
    },
  },
  methods: {
    searchRooms(selectedUnit, index) {
      this.$store.dispatch('rooms/searchRoom', {unitId: selectedUnit, status: 'active'}).then((res) => {
        this.$set(this.userPermissionRepeaterRooms, index, [...res])
      })
    },
    searchRoomById(roomId, index) {
      this.$store.dispatch('rooms/getRoom', roomId).then((res) => {

        this.$set(this.userPermissionRooms[index], 'unitId', res.getUnit._id );
        this.searchRooms(res.getUnit._id, index)
      })
    },
    searchUnits(roomId) {
      this.$store.commit("SET_IS_LOADING", true)

      this.$store.dispatch('units/searchUnitForCurrentUser', {roomId: roomId, status: 'active'}).then(() => {
      this.$store.commit("SET_IS_LOADING", false)

      })
    },
    // searchRooms(index) {
    //   // console.log('searchRooms', this.userPermissionRooms[index])
    //   this.$store.dispatch('rooms/searchRoom', {
    //     unitId: this.userPermissionRooms[index].roomId.unitId,
    //     status: 'active'
    //   }).then((res) => {
    //
    //     this.userPermissionRepeaterRooms[index] = null;
    //     this.$set(this.userPermissionRepeaterRooms, index, [...res])
    //   })
    // },
    getPermissionRooms() {
      this.$store.commit("SET_IS_LOADING", true)
      this.$store.dispatch('permissionRooms/getActivePermissionRooms').then((res) => {
      this.$store.commit("SET_IS_LOADING", false)
      })
    },
    updateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let payload = []
        if (this.userPermissionRooms.length) {
          this.userPermissionRooms.forEach(item => {
            payload.push({roomId: item.roomId, permissionRoomId: item.permissionRoomId})
            // payload.push(_.omitBy(item, (v) => _.isUndefined(v) || _.isNull(v) || v === ''))
          })
          // payload = _.omitBy(payload, (v) => _.isUndefined(v) || _.isNull(v) || v === '')
        }
        payload = payload.map((userPermissionRoom)=>{
          return _.omitBy(userPermissionRoom, (v) => _.isUndefined(v) || _.isNull(v) || v === '' || _.isEmpty(v) );
        })
        payload = payload.filter((obj)=>{
          return !_.isEmpty(obj)
        })
        // _.filter(payload, _.isEmpty)

        this.$store.dispatch('user/editUser', {permissionRooms: payload}).then((res) => {
          this.$root.$bvToast.toast(this.$t('toastification.submissionSucceed'), {
            // title: this.$t('toastification.success'),
            variant: 'success',
            solid: true,
          });
          this.$store.commit('permissions/RESET_PERMISSION_ROOMS')
          // this.$router.push({name:'manageUsers'})
          this.$router.push({name:'assignPermission',params:{userId: this.$route.params.userId}})
        })

      }
    }
  }
}
</script>